import { Inject, Injectable } from "@angular/core";
import { tap, catchError, map, Observable } from "rxjs";
import { ApiResponse, ApiResponseList, PaginatedData } from "../domain/models/apiResponse";
import ErrorsHandler from "./errors-handler";
import IManageMessages from "./ports/i-manage-messages";
import IDisplayTiam from "./ports/display/i-display-tiam";
import IManageTiam from "./ports/manage/i-manage-tiam";
import { RoleUserTiamDto } from "./models/roleTiam";

@Injectable()
export class TiamDisplayer implements IDisplayTiam {
  roles: RoleUserTiamDto[] = [];
  role : string = '';

  constructor(
    private _errorHandler: ErrorsHandler,
    @Inject('IManageTiam') private _rolesManager: IManageTiam,
    @Inject('IManageMessages') private _messagesManager: IManageMessages,
  ) {}
  
  GetStatusRole(role: string): Observable<ApiResponse<string>> {
     return this._rolesManager.GetStatusRole(role).pipe(
            tap(_ => this._messagesManager.add("Fetched tiam status roles")),
            catchError(this._errorHandler.handleError<ApiResponse<string>>('GetStatusRole')),
            map(response => {
            this.role = response.data;
            return response; 
            })
        );
  }
    RequestNewRole(role: string): Observable<ApiResponse<boolean>> {
       return this._rolesManager.RequestNewRole(role).pipe(
            tap(_ => this._messagesManager.add("RequestNewRole")),
            catchError(this._errorHandler.handleError<ApiResponse<boolean>>('RequestNewRole')),
            map(response => {
              return response; 
            })
        );
    }

    GetRolesUserTiam(): Observable<ApiResponseList<RoleUserTiamDto>> {
        return this._rolesManager.GetRolesUserTiam().pipe(
            tap(_ => this._messagesManager.add("Fetched tiam roles")),
            catchError(this._errorHandler.handleError<ApiResponseList<RoleUserTiamDto>>('getTiamRoles')),
            map(response => {
            this.roles = response.data;
            return response; 
            })
        );
    }
}